import { MainColor } from '../../palette';

export const getCircularProgressTheme = () => {
  return {
    gradientColors: {
      start: 'yellow40' satisfies MainColor as MainColor,
      middle: 'navy50' satisfies MainColor as MainColor,
      final: 'forest60' satisfies MainColor as MainColor,
      completed: {
        start: 'logoProgressGradientStart' satisfies MainColor as MainColor,
        end: 'logoProgressGradientEnd' satisfies MainColor as MainColor,
      },
      paused: {
        start: 'coolGrey40' satisfies MainColor as MainColor,
        end: 'coolGrey70' satisfies MainColor as MainColor,
      },
    },
    strokeBackground: 'coolGrey5' satisfies MainColor as MainColor,
    innerShadow: {
      default: 'rgba(0, 0, 0, 0.25)' as MainColor,
      disabled: 'rgba(0, 0, 0, 0.40)' as MainColor,
    },
  };
};

export type CircularProgressTheme = ReturnType<typeof getCircularProgressTheme>;
